module.exports = __webpack_public_path__ + "9f5e9492f8c69a9b885eae99c9aac83f.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/back-dark-18.svg
// module id = 509
// module chunks = 74